// UI Component: StatusBar
import { LanguageSelector } from './LanguageSelector';

export class StatusBar {
  private statusFile: HTMLElement;
  private statusLanguage: HTMLElement;
  private statusPosition: HTMLElement;
  private languageSelector: LanguageSelector;
  private onLanguageChangeCallback?: (language: string) => void;

  constructor(element: HTMLElement) {
    this.statusFile = element.querySelector('#status-file')!
    this.statusLanguage = element.querySelector('#status-language')!;
    this.statusPosition = element.querySelector('#status-position')!;

    // Initialize language selector
    this.languageSelector = new LanguageSelector();
    
    // Make language clickable
    this.statusLanguage.style.cursor = 'pointer';
    this.statusLanguage.title = 'Click to change language';
    this.statusLanguage.addEventListener('click', (e) => {
      e.stopPropagation();
      this.languageSelector.show(this.statusLanguage);
    });

    // Handle language selection
    this.languageSelector.onSelect((language) => {
      if (this.onLanguageChangeCallback) {
        this.onLanguageChangeCallback(language);
      }
    });
  }

  updateFile(fileName: string): void {
    this.statusFile.textContent = fileName;
  }

  updateLanguage(language: string): void {
    // Convert language ID to display name
    const displayName = this.getLanguageDisplayName(language);
    this.statusLanguage.textContent = displayName;
    this.languageSelector.highlightLanguage(language);
  }

  updatePosition(line: number, column: number): void {
    this.statusPosition.textContent = `Ln ${line}, Col ${column}`;
  }

  onLanguageChange(callback: (language: string) => void): void {
    this.onLanguageChangeCallback = callback;
  }

  private getLanguageDisplayName(languageId: string): string {
    const languageMap: Record<string, string> = {
      javascript: 'JavaScript',
      typescript: 'TypeScript',
      python: 'Python',
      html: 'HTML',
      css: 'CSS',
      json: 'JSON',
      markdown: 'Markdown',
      xml: 'XML',
      yaml: 'YAML',
      shell: 'Shell Script',
      sql: 'SQL',
      php: 'PHP',
      java: 'Java',
      csharp: 'C#',
      cpp: 'C++',
      go: 'Go',
      rust: 'Rust',
      plaintext: 'Plain Text',
    };
    return languageMap[languageId] || languageId;
  }

  destroy(): void {
    this.languageSelector.destroy();
  }
}
